<template>
  <div>
    <b-card title="ECommerce Setup / Users" class="mb-4 shadow-sm">
      <!-- Header Section -->
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
        <div class="mb-2 mb-md-0">
          <h4 class="mb-0">Manage Setup</h4>
          <p class="text-muted mb-0">Configure your e-commerce store settings here.</p>
        </div>
        <div class="d-flex gap-2">
  <!-- Show 'Users' button if user is an Admin -->
  <!-- <b-button v-if="hasAdmin" variant="success" @click="redirectToUsers">
    Users
  </b-button> -->

  <!-- Show 'Set Up Account' button if user is NOT an Admin -->
  <b-button v-if="!hasAdmin" variant="success" @click="showAddUserModal = true">
    Set Up Account
  </b-button>

  <!-- 'Visit Store' button always visible -->
  <b-button variant="outline-primary" @click="redirectToStore">
    Visit Store
  </b-button>
</div>



      </div>

      <!-- Add User Modal -->
      <b-modal v-model="showAddUserModal" title="Setup Ecommerce" hide-footer centered>
        <template #modal-header>
          <div class="d-flex align-items-center">
            <b-icon icon="gear" class="me-2"></b-icon>
            <h5 class="mb-0">Setup Ecommerce</h5>
          </div>
        </template>
        <validation-observer ref="addUser" #default="{ invalid }">
        <b-form @submit.prevent="addUser">
          <!-- Email -->
          <b-form-group label="Email" label-for="email">
            <validation-provider #default="{ errors }" name="Email" vid="Email" rules="required|email_regex">
            <b-form-input
              type="email"
              id="email"
              v-model="newUser.email"
              placeholder="Enter your email (e.g., example@domain.com)"
            ></b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group>

          <!-- Username -->
          <b-form-group label="Username" label-for="username">
            <validation-provider #default="{ errors }" name="Username" vid="Username" rules="required">
            <b-form-input
              id="username"
              v-model="newUser.username"
              placeholder="Enter username"
            ></b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group>

          <!-- Password -->
          <b-form-group label="Password" label-for="password">
            <validation-provider #default="{ errors }" name="Password" vid="Password" rules="required">
            <b-form-input
              type="password"
              id="password"
              v-model="newUser.password"
              placeholder="Enter password"
            ></b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group>

          <!-- Shop Name -->
          <b-form-group label="Shop Name" label-for="shopName">
            <validation-provider #default="{ errors }" name="Shop Name" vid="Shop Name" rules="required">
            <b-form-input
              id="shopName"
              v-model="newUser.shopName"
              placeholder="Enter shop name"
            ></b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex justify-content-end gap-2 mt-4">
            <b-button variant="secondary" @click="showAddUserModal = false">
              Cancel
            </b-button>
            <b-button type="button" @click="addUser" variant="primary">
              <b-icon icon="check" class="me-2"></b-icon>
              Submit
            </b-button>
          </div>
        </b-form>
      </validation-observer>
      </b-modal>
    </b-card>
     <!-- Users Table Below Setup Section -->
     <b-card title="ECommerce Users" class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <label for="perPage" class="form-label">Per page</label>
          <b-form-select id="perPage" v-model="perPage" :options="perPageOptions" class="w-auto"></b-form-select>
        </div>
      </div>

      <b-table
        :items="userEntries"
        :fields="fields"
        responsive="sm"
        bordered
        :per-page="perPage"
        :current-page="currentPage"
      >
        <!-- <template #cell(action)="data">
          <b-button variant="primary" @click="convertToCustomer(data.item)">Convert to Customer</b-button>
        </template> -->
      </b-table>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <div>Showing {{ firstItem }} to {{ lastItem }} of {{ totalEntries }} entries</div>
        <b-pagination v-model="currentPage" :total-rows="totalEntries" :per-page="perPage" align="right" size="sm"></b-pagination>
      </div>
    </b-card>
  </div>
</template>



<script>
import {
  BTable,
  BButton,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BCard,
  BPagination,
  BFormSelect,
  BIcon,
} from "bootstrap-vue";
import { mapActions, mapGetters  } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend } from "vee-validate";

extend("email_regex", {
  validate: value =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
  message: "Please enter a valid email address in the format example@domain.com",
});

export default {
  components: {
    BTable,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BCard,
    BPagination,
    BFormSelect,
    BIcon,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      showAddUserModal: false,
      hasAdmin : false,
      userEntries: [],
      newUser: {
        email: "",
        username: "",
        password: "",
        shopName: "",
      },
      fields: [
        { key: "userName", label: "Username", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "phoneNumber", label: "Phone", sortable: true },
        // { key: "action", label: "Action" },
      ],
      perPageOptions: [5, 10, 15, 20],
      perPage: 5,
      currentPage: 1,
    };
    
  },
  computed: {

    totalEntries() {
    return this.userEntries ? this.userEntries.length : 0;
  },
  firstItem() {
    if (this.totalEntries === 0) return 0;
    return (this.currentPage - 1) * this.perPage + 1;
  },
  lastItem() {
    if (this.totalEntries === 0) return 0;
    return Math.min(this.currentPage * this.perPage, this.totalEntries);
  },
    
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.newUser.email);
    },
    validateUsername() {
      return this.newUser.username.length > 0;
    },
    validatePassword() {
      const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,15}$/;
      return passwordRegex.test(this.newUser.password);
    },
    validateShopName() {
      return this.newUser.shopName.length > 0;
    },
    isFormInvalid() {
      return (
        !this.validateEmail ||
        !this.validateUsername ||
        !this.validatePassword ||
        !this.validateShopName
      );
    },
  },
  methods: {
    ...mapActions("ecommerceModule", ["postAdminAction", "getUserListAction"]),

    redirectToStore() {
      const tenantName = localStorage.getItem("userTenant");
      if (tenantName) {
        const storeUrl = `${process.env.VUE_APP_ECOM_URL}${tenantName}`;

        window.open(storeUrl, "_blank");
      } else {
        alert("Tenant name not found!");
      }
    },

    redirectToUsers() {
    this.$router.push("/ecommerce/user"); // Adjust the route based on your app
  },

    async addUser() {
      let isValid = await this.$refs.addUser.validate();
      if (isValid) {
      const loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the draft is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      const payload = {
        email: this.newUser.email,
        userName: this.newUser.username,
        password: this.newUser.password,
        tenantSetting: {
          shopName: this.newUser.shopName,
        },
      };

      try {
        await this.postAdminAction(payload);
        this.$swal("Success", "Admin added successfully!", "success");
        this.newUser = {
          email: "",
          username: "",
          password: "",
          shopName: "",
        };
        this.showAddUserModal = false;
      } catch (error) {
        this.$swal("Error", "Failed to add admin.", "error");
        console.error(error);
      }
    }
    },
  },

  async mounted() {
  this.loading = true; 
  try {
    this.$swal({
      title: "Loading Data...",
      text: "Please wait while we fetch user data.",
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });

    const response = await this.getUserListAction();
    this.userEntries = response || []; 
    this.hasAdmin = this.userEntries.some(user => user.roles.includes("Admin"));

    this.$swal.close(); 
  } catch (error) {
    console.error("Error fetching user list:", error);
    this.$swal.fire("Error", "Failed to load user data. Please try again.", "error");
  } finally {
    this.loading = false; 
  }
}
,
};
</script>

<style scoped>
/* Custom Card Styling */
.b-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Button Styling */
.btn-success {
  background-color: #28a745;
  border-color: #28a745;
  transition: background-color 0.3s ease;
}

.btn-success:hover {
  background-color: #218838;
  border-color: #1e7e34;
}

.btn-outline-primary {
  border-color: #007bff;
  color: #007bff;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-outline-primary:hover {
  background-color: #007bff;
  color: #fff;
}

/* Form Styling */
.b-form-input {
  border-radius: 8px;
  border: 1px solid #ced4da;
  transition: border-color 0.3s ease;
}

.b-form-input:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Modal Styling */
.modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 12px 12px 0 0;
}

/* Spacing Utilities */
.gap-2 {
  gap: 0.5rem;
}

.mt-4 {
  margin-top: 1.5rem;
}

/* Icon Styling */
.b-icon {
  vertical-align: middle;
}
</style>